import { BlockPickerOption } from '../BlockPickerPlugin/BlockPickerOption';
import { OPEN_FILE_UPLOAD_MODAL_COMMAND } from '../EncryptedFilePlugin/FilePlugin';
export function GetUploadFileOption(editor) {
    return new BlockPickerOption('Upload file', {
        iconName: 'file',
        keywords: ['image', 'upload', 'file'],
        onSelect: () => editor.dispatchCommand(OPEN_FILE_UPLOAD_MODAL_COMMAND, undefined),
    });
}
